import React, { useContext, useEffect, useState } from "react";

import axios from "axios";
import { Card, Spinner } from "react-bootstrap";
import PsContext from "../../context";
import { MOB_ICONS, NoData, groupByMultiple, momentDate } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";

const MyAbsentDays = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);
  const [showAtt, setShowAtt] = useState(false);

  useEffect(() => {
    if (showAtt && dataList.length < 1) loadData();
  }, [showAtt]);

  const loadData = () => {
    setLoader(true);
    const form = new FormData();
    form.append("type", props.type);
    form.append("college_uuid", context.user.college_uuid);
    axios.post(ServiceUrl.STUDENTS.MY_ATTENDANCE_ABSENT, form).then((res) => {
      if (res.data.status == "1") {
        let s = groupByMultiple(res.data.data, function (obj) {
          return [obj.attendance_date];
        });
        setDataList(res.data.data);
        setDataView(s);
      }
      setLoader(false);
    });
  };

  return (
    <>
      <Card onClick={(e) => setShowAtt(!showAtt)}>
        <Card.Header className="card-header-bg text-uppercase fw-bold">
          <span className="float-start">
            My {props.type == "od" ? "OD " : "Absent "} Days
          </span>
          <span className="float-end">
            {showAtt ? (
              <i className="fa-solid fa-chevron-down"></i>
            ) : (
              <i className="fa-solid fa-chevron-right"></i>
            )}
          </span>
        </Card.Header>
        <Card.Body className="p-0">
          {showAtt && (
            <div style={{ minHeight: "100px" }} className="bg-white">
              {loader && (
                <div className="text-center py-4">
                  <Spinner animation="border" role="status" />
                </div>
              )}

              {!loader && dataView.length < 1 && <NoData imgWidth="130px" />}
              {!loader && dataView.length > 0 && (
                <div className="p-2">
                  <table className="table table-sm">
                    <thead className="table-light">
                      <tr>
                        <th width="120">Date</th>
                        <th className="text-end" align="right">
                          Hours
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataView.map((item, i) => {
                        return (
                          <tr key={i}>
                            <td>
                              {momentDate(
                                item[0].attendance_date,
                                "DD-MM-YYYY"
                              )}
                              <br />
                              {momentDate(item[0].attendance_date, "dddd")}
                            </td>
                            <td align="right">
                              {item.map((j) => (
                                <span>{`${j.hour_value}, `}</span>
                              ))}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
export default MyAbsentDays;
